module.exports = __webpack_public_path__ + "img/self.857ae32e.png";